<template>
  <Main>
    <v-container>
      <v-card class="mx-auto">
        <v-card-text>
          <p class="display-1 text--primary">
            Upload Fixed Call
            <v-btn small color="warning" @click="downloadCSVWithData()">Download Template</v-btn>
          </p>
          <div class="text--primary">
            <v-row>
              <v-col md="12" sm="12">
                <v-file-input color="red darken-1" counter label="File input" placeholder="Select your files"
                  prepend-icon="mdi-paperclip" outlined :show-size="1000" @change="onAddFiles($event)">
                  <template v-slot:selection="{ index, text }">
                    <v-chip v-if="index < 2" color="deep-purple accent-4" dark label small>
                      {{ text }}
                    </v-chip>

                    <span v-else-if="index === 2" class="overline grey--text text--darken-3 mx-2">
                      +{{ files.length - 2 }} File(s)
                    </span>
                  </template>
                </v-file-input>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
      </v-card>

      <v-card class="mx-auto my-3">
        <v-card-text>
          <v-tabs color="white accent-4" fixed-tabs center background-color="indigo" dark>
            <v-tab>Error Fix Call</v-tab>
            <v-tab>Clean Data</v-tab>

            <v-tab-item :key="1">
              <v-container fluid>
                <v-row>
                  <v-col class="py-0" md="9" sm="9">
                    <v-text-field color="red darken-1" v-model="searchErrorData" append-icon="mdi-magnify"
                      label="Search Data" single-line hide-details></v-text-field>
                  </v-col>
                  <v-col md="3" sm="3">
                    <v-btn small color="warning" class="float-right" style="width: 100%"
                      @click="downloadCSVError()">Export Error Mapping</v-btn>
                  </v-col>
                  <v-col md="12" sm="12">
                    <v-data-table :headers="dtHeaders" :items="dtItemsFail" :search="searchErrorData"
                      v-bind:allow-multiple="false" :loading="dtLoading" :item-class="itemRowValidation"
                      loading-text="Fetching Data...">
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>

            <v-tab-item :key="2">
              <v-container fluid>
                <v-row>
                  <v-col class="py-0" md="7" sm="7">
                    <v-text-field color="red darken-1" v-model="searchCleanData" append-icon="mdi-magnify"
                      label="Search Data" hide-details></v-text-field>
                  </v-col>
                  <v-col md="5" sm="5">
                    <v-btn small color="warning" class="float-right" :disabled="disableSubmit"
                      @click="confirmModal(submitUpload)">Submit Uploaded File</v-btn>
                    <v-btn small color="warning" class="float-right mr-3" @click="downloadCSVSuccess()">Export Clean
                      Data</v-btn>
                  </v-col>
                  <v-col md="12" sm="12">
                    <v-data-table :headers="dtHeaders" :items="dtItemsSuccess" :search="searchCleanData"
                      v-bind:allow-multiple="false" :loading="dtLoading" :item-class="itemRowValidation"
                      loading-text="Fetching Data...">
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>
          </v-tabs>
        </v-card-text>
      </v-card>
    </v-container>
    <!-- SNACKBAR -->
    <v-snackbar v-model="isShowSnackbar" top>{{ snackbarText }}</v-snackbar>
    <!-- LOADING OVERLAY -->
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- Start Validation Submit -->
    <v-dialog v-model="isOpenModalConfirm" max-width="500px">
      <v-card>
        <v-card-title class="headline"><b style="color: red">[IMPORTANT]</b>&nbsp;&nbsp;Are you Sure to Continue
          ?</v-card-title>

        <v-card-text>
          Jika anda menekan tombol submit, sistem akan melakukan input seluruh data yang
          sudah melalui validasi saja. Apakah anda yakin untuk melanjutkan ?
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="red darken-1" text @click="isOpenModalConfirm = false">Cancel</v-btn>

          <v-btn color="green darken-1" text @click="methodAction">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End Validation Submit -->
  </Main>
</template>

<style>
.not-valid {
  background-color: rgb(255, 210, 210);
}

td {
  white-space: nowrap;
}
</style>

<script>
import Main from "@/Main.vue";
import XLSX from "xlsx";
import moment from "moment";

// Import the plugin code
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";

// Import Vue FilePond
import vueFilePond, { setOptions } from "vue-filepond";

// Import FilePond styles
import "filepond/dist/filepond.min.css";

// Create component
const FilePond = vueFilePond(FilePondPluginFileValidateType);

setOptions({
  allowMultiple: false,
});

const JSON_FOR_DOWNLOAD = [
  // {
  //   YearID: "",
  //   MonthID: "",
  //   Period: "",
  //   Branch: "",
  //   Positioncode: "",
  //   Type: "",
  //   CustomerID_REF: "",
  //   CustomerName: "",
  //   Hari: "",
  //   Freq: "",
  //   Week: "",
  // },
  {
    YEARID: "",
    PERIODE: "",
    BRANCH_CODE: "",
    POSITION_DESC: "",
    TYPE_SALESMAN: "",
    CUSTOMERID_REF: "",
    CUSTOMER_NAME: "",
    DAYS: "",
    FREQUENCY: "",
    WEEK: ""
  },
];

export default {
  components: {
    Main,
    FilePond,
  },
  data() {
    return {
      searchCleanData: "",
      searchErrorData: "",
      methodAction: "",
      isOpenModalConfirm: false,
      disableSubmit: true,
      FILE_UPLOAD: [],
      JSON_FILE_UPLOAD: [],
      search: "",
      dtLoading: false,
      isShowSnackbar: false,
      snackbarText: "",
      isLoading: false,
      dtLoading: false,
      dtHeaders: [
        {
          text: "YEAR",
          value: "YEARID",
        },
        {
          text: "PERIODE",
          value: "PERIODE",
        },
        {
          text: "BRANCH CODE",
          value: "BRANCH_CODE",
        },
        {
          text: "POSITION",
          value: "POSITION_DESC",
        },
        {
          text: "TYPE SALESMAN",
          value: "TYPE_SALESMAN",
        },
        {
          text: "CUSTOMERID REF",
          value: "CUSTOMERID_REF",
        },
        {
          text: "CUSTOMER NAME",
          value: "CUSTOMER_NAME",
        },
        {
          text: "DAYS",
          value: "DAYS",
        },
        {
          text: "FREQUENCY",
          value: "FREQUENCY",
        },
        {
          text: "WEEK",
          value: "WEEK",
        },
        {
          text: "REASON",
          value: "REASON",
        },
      ],
      dtItemsSuccess: [],
      dtItemsFail: [],
      previews: [],
      dtValidPeriod: ""
    };
  },
  mounted() {
    this.cekPeriod();
  },
  methods: {
    itemRowValidation: function (item) {
      return item.IS_VALID == "Y" ? "" : "not-valid";
    },
    confirmModal: function (method) {
      this.isOpenModalConfirm = true;
      this.methodAction = method;
    },
    cekPeriod() {
      const userData = JSON.parse(localStorage.getItem("userData"));
      this.isLoading = true;
      let data = {
        typeID: 'FIXED CALL PLAN',
        orgID: userData.ORG_ID
      };
      this.$http
        .post("/setting/validPeriod", data, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then(res => {
          this.isLoading = false;
          const {
            success,
            message,
            data
          } = res.data;
          this.dtValidPeriod = data.length;
        })
        .catch(err => {
          this.isLoading = false;
          this.showSnackbar(err.toString());
        });
    },
    onAddFiles(event) {
      if (this.dtValidPeriod > 0) {
        try {
          let self = this;
          let file = event;
          const userData = JSON.parse(localStorage.getItem("userData"));
          const reader = new FileReader();
          this.dtItems = [];
          this.disableSubmit = false;

          reader.onload = (e) => {
            var data = new Uint8Array(e.target.result);
            var workbook = XLSX.read(data, {
              type: "array",
              cellDates: true,
            });

            let sheetName = workbook.SheetNames[0];
            /* DO SOMETHING WITH workbook HERE */
            let worksheet = workbook.Sheets[sheetName];
            const XLSXJSON = XLSX.utils.sheet_to_json(worksheet);

            for (let XLSXJSONDATA of XLSXJSON) {
              if (
                XLSXJSONDATA.YEARID != undefined &&
                XLSXJSONDATA.PERIODE != undefined &&
                XLSXJSONDATA.BRANCH_CODE != undefined &&
                XLSXJSONDATA.POSITION_DESC != undefined &&
                XLSXJSONDATA.TYPE_SALESMAN != undefined &&
                XLSXJSONDATA.CUSTOMERID_REF != undefined &&
                XLSXJSONDATA.CUSTOMER_NAME != undefined &&
                XLSXJSONDATA.DAYS != undefined &&
                XLSXJSONDATA.FREQUENCY != undefined &&
                XLSXJSONDATA.WEEK != undefined
              ) {
                this.isLoading = true;
                if (file.type == "application/vnd.ms-excel") {
                  let VALIDITY = true;
                  let VALIDITY_REASON = "";
                  const listDay = [
                    "SENIN",
                    "SELASA",
                    "RABU",
                    "KAMIS",
                    "JUMAT",
                    "SABTU",
                    "MINGGU",
                  ];

                  if (!listDay.includes(XLSXJSONDATA.DAYS)) {
                    VALIDITY = false;
                    VALIDITY_REASON = "Nama Hari tidak Sesuai";
                  }

                  if (XLSXJSONDATA.WEEK > 4) {
                    VALIDITY = false;
                    VALIDITY_REASON = "Week Tidak Sesuai";
                  }
                  self.dtItems.push({
                    userORGID: userData.ORG_ID,
                    YearID: XLSXJSONDATA.YEARID,
                    MonthID: 0,
                    Periode: XLSXJSONDATA.PERIODE,
                    BranchCode: XLSXJSONDATA.BRANCH_CODE,
                    PositionCode: XLSXJSONDATA.POSITION_DESC,
                    TypeSalesman: XLSXJSONDATA.TYPE_SALESMAN,
                    CustomerIDRef: XLSXJSONDATA.CUSTOMERID_REF,
                    CustomerName: XLSXJSONDATA.CUSTOMER_NAME,
                    Days: XLSXJSONDATA.DAYS,
                    Frequency: XLSXJSONDATA.FREQUENCY,
                    Week: XLSXJSONDATA.WEEK,
                    UserID: userData.USER_ID,
                    isValid: VALIDITY,
                    Reason: VALIDITY_REASON,
                  });
                } else if (
                  file.type ==
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                ) {
                  self.isLoading = false;
                  self.isOpenModalConfirm = false;
                  self.showSnackbar("Gunakan template XLS");
                }
              }
            }
            if (self.dtItems.length > 0) {
              self.isOpenModalConfirm = false;
              self.isLoading = true;
              self.$http
                .post("/call-management/validation", {
                  excelData: self.dtItems,
                  orgID: userData.ORG_ID,
                }, {
                  headers: {
                    "api-key": this.$apiKey
                  }
                })
                .then((res) => {
                  const { success, data, message } = res.data;
                  let valid = true;
                  let reason = "";
                  if (success) {
                    self.isLoading = false;
                    if (data.failed[0] != undefined) {
                      self.dtItemsSuccess = data.success;
                      self.dtItemsFail = data.failed;
                      self.disableSubmit = true;
                      self.showSnackbar(message);
                    } else {
                      self.isLoading = false;
                      self.dtItemsSuccess = data.success;
                      self.dtItemsFail = data.failed;
                      self.showSnackbar(message);
                    }
                  } else {
                    self.isLoading = false;
                    self.showSnackbar(message);
                  }
                })
                .catch((err) => {
                  self.isLoading = false;
                  self.showSnackbar(err.toString());
                });
            } else {
              self.isLoading = false;
              self.isOpenModalConfirm = false;
              // Edited By Dedian 29 Juli 2021 //
              self.showSnackbar("Gunakan template XLS");
            }
          };

          if (file) {
            reader.readAsArrayBuffer(file);
          }
        } catch (e) {
          this.isLoading = false;
          this.isOpenModalConfirm = false;
          this.showSnackbar(e);
        }
      } else {
        this.showSnackbar(
          "Periode sudah ditutup."
        );
      }
    },
    submitUpload() {
      if (this.dtItemsSuccess.length > 0) {
        this.isOpenModalConfirm = false;
        this.isLoading = true;
        const userData = JSON.parse(localStorage.getItem("userData"));
        this.$http
          .post("/call-management/uploadfixedcall", {
            dtItemsSuccess: this.dtItemsSuccess,
            orgID: userData.ORG_ID,
            userID: userData.USER_ID,
          }, {
            headers: {
              "api-key": this.$apiKey
            }
          })
          .then((res) => {
            this.isLoading = false;
            const { success, data, message } = res.data;
            if (success) {
              this.canExport = false;
              this.canSubmit = true;
              this.dtItemsSuccess = [];
              this.showSnackbar(message);
            } else {
              this.showSnackbar(message);
            }
          })
          .catch((err) => {
            this.isLoading = false;
            this.showSnackbar(err.toString());
          });
      } else {
        this.isLoading = false;
        this.isOpenModalConfirm = false;
        this.showSnackbar("Please Upload CSV File First !");
      }
    },
    downloadCSVWithData() {
      this.isLoading = true;
      let orgID = JSON.parse(localStorage.getItem("userData")).ORG_ID;
      // orgID = 221;
      this.$http
        .post("/call-management/downloadtemplatefc", { orgID: orgID }, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          this.isLoading = false;
          const { success, data, message } = res.data;
          if (data.length > 0) {
            let dataToExcell = [];
            data.forEach((obj, index) => {
              dataToExcell.push({
                YEARID: data[index].YEAR_ID,
                PERIODE: data[index].PERIODE,
                BRANCH_CODE: data[index].BRANCH_CODE,
                POSITION_DESC: data[index].POSITION_DESC,
                TYPE_SALESMAN: data[index].TYPE_SALESMAN,
                CUSTOMERID_REF: data[index].CUSTOMERID_REF,
                CUSTOMER_NAME: data[index].CUSTOMER_NAME,
                DAYS: data[index].DAYS,
                FREQUENCY: data[index].FREQUENCY,
                WEEK: data[index].WEEK
              })
            });
            this.downloadCSV(dataToExcell);
          } else {
            this.downloadCSV(JSON_FOR_DOWNLOAD);
          }

        })
        .catch((err) => {
          this.isLoading = false;
          this.showSnackbar(err.toString());
        });
    },
    downloadCSV(dataToExcell) {
      const workBook = XLSX.utils.book_new(); // create a new blank book
      const workSheet = XLSX.utils.json_to_sheet(dataToExcell);
      XLSX.utils.book_append_sheet(workBook, workSheet, "Sheet1"); // add the worksheet to the book
      XLSX.writeFile(workBook, "Template Upload Fixed Call.xlsx"); // initiate a file download in browser
      this.isLoading = false;
    },
    downloadCSVError() {
      const workBook = XLSX.utils.book_new(); // create a new blank book
      const workSheet = XLSX.utils.json_to_sheet(this.dtItemsFail);
      XLSX.utils.book_append_sheet(workBook, workSheet, "Sheet1"); // add the worksheet to the book
      XLSX.writeFile(workBook, "Error Fix Call.xls"); // initiate a file download in browser
    },
    downloadCSVSuccess() {
      const workBook = XLSX.utils.book_new(); // create a new blank book
      const workSheet = XLSX.utils.json_to_sheet(this.dtItemsSuccess);
      XLSX.utils.book_append_sheet(workBook, workSheet, "Sheet1"); // add the worksheet to the book
      XLSX.writeFile(workBook, "Valid Data Fix Call.xls"); // initiate a file download in browser
    },
    showSnackbar(text) {
      this.snackbarText = text;
      this.isShowSnackbar = true;
    },
  },
};
</script>
